<template>
  <div id="bdm_center" :class="isFull === 1 ? 'bdm_center0 top_information1' : ' bdm_center0'">
    <van-nav-bar :title="$t('column.bdm_center',{name:role_type_title})" placeholder fixed left-arrow >
        <template #left>
            <img src="../assets/img/bdm/bdm_left.png" alt="" height="20vw" @click="onClickLeft">
        </template>
        <template #right>
            <img src="../assets/img/bdm/bdm_center_log.png" alt="" height="20vw" @click="jump_href">
        </template>
    </van-nav-bar>
    <van-row>
        <!--顶部背景-->
        <van-col span="22" offset="1" class="bdm_center_info">
            <van-col span="8"  class="bdm_center_info_join_time">{{ $t('column.join_date') }}: {{ info.created_at }}</van-col>
            <van-col span="14" offset="1" class="bdm_center_info_user_info">
                <van-col span="5" style="text-align: center;"> 
                    <van-image
                    width="30"
                    height="30"
                    round
                    :src="info.head_image"
                    />
                </van-col>
                <van-col span="16">
                    <van-col span="24" class="bdm_center_info_user_name">{{ info.nick_name }}<img :src="info.country_img" v-if="info.country_img"/></van-col>
                    <van-col span="24" class="bdm_center_info_user_id">ID:{{ info.uid }}</van-col>
                </van-col>
            </van-col>
            <van-col span="7" offset="8" class="bdm_center_info_total3 bdm_center_bg1">
                <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.total_claim') }}</van-col>
                <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ info.total_coin }}</van-col>
            </van-col>
             <van-col span="24">
                 <van-col span="7" offset="3" class="bdm_center_info_total bdm_center_bg2">
                    <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.this_month') }}</van-col>
                    <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ info.month_coin }}</van-col>
                </van-col>
                <van-col span="7" offset="3" class="bdm_center_info_total bdm_center_bg3">
                    <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.last_month') }}</van-col>
                    <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ info.last_month_coin }}</van-col>
                </van-col>
             </van-col>
        </van-col>
        <!--收益明细-->
         <van-col span="22" offset="1" class="bdm_center_coin">
            <van-col span="24" class="bdm_center_coin_list" v-for="(item,i) in coin_list" :key="i">
                <van-col span="6" class="bdm_center_coin_list_type">
                     <van-col span="24" class="bdm_center_info_total1 bdm_center_bg4">
                        <van-col span="24" class="bdm_center_info_total_name">{{ item.type_name }}</van-col>
                        <van-col span="24" class="bdm_center_info_total_sum2">
                          <img src="../assets/img/bdm/icon_guid.png" alt="" v-if="item.type =='admin'">
                          <img src="../assets/img/bdm/coin_merchant.png" alt="" v-else-if="item.type =='coin_seller'">
                          <img src="../assets/img/bdm/ic_in_bd.png" alt="" v-else-if="item.type =='bd'">
                          <img src="../assets/img/bdm/ic_agc_mang.png" alt="" v-else>
                          {{ item.total_people }}
                        </van-col>
                     </van-col>
                </van-col>
               <van-col span="6" class="bdm_center_coin_list_type">
                     <van-col span="24" class="bdm_center_info_total1 bdm_center_bg5">
                        <van-col span="24" class="bdm_center_info_total_name">{{ item.total_name }}</van-col>
                        <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ item.total_earning }}</van-col>
                     </van-col>
                </van-col>
                <van-col span="6" class="bdm_center_coin_list_type">
                     <van-col span="24" class="bdm_center_info_total bdm_center_bg6">
                        <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.this_month') }}</van-col>
                        <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ item.month }}</van-col>
                     </van-col>
                </van-col>
                <van-col span="6" class="bdm_center_coin_list_type">
                     <van-col span="24" class="bdm_center_info_total bdm_center_bg7">
                        <van-col span="24" class="bdm_center_info_total_name">{{ $t('column.last_month') }}</van-col>
                        <van-col span="24" class="bdm_center_info_total_sum"><img src="../assets/img/coin9.png" alt="">{{ item.last_month }}</van-col>
                     </van-col>
                </van-col>
            </van-col>
         </van-col>
         <!--任务-->
         <!--Admin Earning Task-->
        <van-col span="22" offset="1" class="bdm_center_task" v-for="(t,j) in task_list" :key="j">
            <van-col span="24"class="bdm_center_task_bottom">
                <van-col span="16">
                    <span class="bdm_center_task_bao"><img src="../assets/img/bdm/ic_weight_pop_3.png" alt=""/>{{ t.title }}</span>
                </van-col>
                <van-col span="8" class="bdm_center_task_img">
                    <img src="../assets/img/bdm/baat_iv_reward_top_dialog_bg_new.png" alt="">
                </van-col>
            </van-col>
            <!-- 任务列表 -->
            <van-col span="24" class="bdm_center_task_list" v-for="(v,k) in t.list" :key="k">
                <van-col span="4" class="bdm_center_task_list_l">
                    <img src="../assets/img/bdm/coin_merchant.png" alt="" v-if="t.type=='coin_seller'"/>
                    <img src="../assets/img/bdm/ic_te.png" alt="" v-else/>
                </van-col>
                <van-col span="14" class="bdm_center_task_list_c"> 
                    <van-col span="24" class="bdm_center_task_list_c_title">{{ $t('column.monthly_target') }} <img src="../assets/img/coin9.png" />{{ v.threshold_amount_text }}</van-col>
                    <van-col span="24" class="bdm_center_task_list_c_b">
                        <van-col span="12" class="bdm_center_task_list_c_progress"> 
                            <van-progress :percentage="v.claim_progress" track-color="#F9D7FF" :color="(progress_color[t.type] || progress_color['admin'])[k % 7]" :show-pivot="false"/>
                        </van-col>
                       <van-col span="12" class="bdm_center_task_list_c_b_sum">
                          <span class="bdm_center_task_list_c_b_sum_bg">{{ v.progress_coin }}/{{ v.threshold_amount_text }}<img src="../assets/img/coin9.png" alt=""/></span>
                       </van-col>
                    </van-col>
                </van-col>
                <van-col span="6" :class="[v.claim_status == 1 ? 'bdm_center_task_list_r0' : 'bdm_center_task_list_r']" @click.native="claimCoin(v)"> 
                    <van-col span="24" class="bdm_center_task_list_r_name">{{ v.claim_status == 1 ? $t('column.done') : $t('column.claim') }}</van-col>
                    <van-col span="24" class="bdm_center_task_list_r_sum"><img src="../assets/img/coin9.png" />{{ v.reward_amount_text }}</van-col>
                </van-col>
             </van-col>
        </van-col>
        <van-overlay :show="loading" z-index="2003">
            <van-loading type="spinner" class="loading_overlay"/>
        </van-overlay>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast } from 'vant'

export default {
  data:function() {
    return {
      info:{
        total_coi: 0,
        month:0,
        last_month:0,
        uid: undefined,
        id:0,
        role_type: 0,
        created_at: undefined,
        nick_name: undefined,
        head_image: undefined,
        country_img: undefined
      },
      coin_list: [],
      task_list: [],
      loading: false,
      finished: false,
      progress_color:{
        admin:['#FF4CC5','#2BF475','#FFD008','#11D7BB','#17A5E5','#FF611C','#DCB149'],
        coin_seller:['#2BF475','#FFD008','#11D7BB','#17A5E5','#FF611C','#DCB149','#FF4CC5'],
        bd:['#FFD008','#11D7BB','#17A5E5','#FF611C','#DCB149','#FF4CC5','#2BF475'],
        agc:['#11D7BB','#17A5E5','#FF611C','#DCB149','#FF4CC5','#2BF475','#FFD008'],
      },
      role_type_title:'',
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      source: 'app'
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.source = this.$route.query.source ? this.$route.query.source : 'app'
    this.get_list()
  },
  methods: {
    claimCoin(item){
      // 领取 claim_task_rewards
      if(item.claim_status == 0){
        this.loading = true
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=claim_task_rewards", {
          params : {
              id: item.id,
              token: token
          }
        }).then(res =>{
          this.loading = false
          Toast(res.data.error)
          this.get_list()
        })
      }
    },
    onClickLeft() {
      if(this.source == 'app'){
        // 拦截关闭h5
        window.location.href="bogolive://exit"
      }else{
        // 返回上一页
        this.$router.go(-1)
      }
    },
    getCode() {
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=get_verify_code", {
        params : {
            to_user_id: this.inviterId,
            token: token,
            role_type: this.roleType
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
      })
    },
    jump_href(){
      // 跳转奖励记录
      this.$router.push({ name: 'bdm_reward_log', query: { token: this.$route.query.token, is_full: this.isFull } })
    },
    Jump_intercept(item) {
      // 拦截返回app
      window.location.href="live://live?action=recharge&id="+ item.id
    },
    showAddBtn(type,role_type) {
        this.addType = type
        this.roleType = role_type
        this.inviterId = ''
        this.verificationCode = ''
        this.progress = this.addType === 'admin_add' ? this.admin_number / this.bdm_administrator_restrictions * 100 : this.coin_seller_number / this.bdm_coin_seller_restrictions * 100
        this.popup_title = this.$t('column.' + this.addType)
        this.showAdd = true
    },
    showAddPayrollBtn(){
      this.inviterId = ''
      this.popup_title = this.$t('column.payroll_request')
      this.showPayroll = true
    },
    confirmPayrollAdd(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=apply_settlement", {
        params : {
            to_user_id: this.inviterId,
            token: token,
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
            this.showPayroll = false
            this.get_list()
        }
      }).catch(err => {
        this.loading = false
      })
    },
    confirmAdd() {
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=add_bdm", {
        params : {
            to_user_id: this.inviterId,
            verify_code: this.verificationCode,
            token: token,
            role_type: this.roleType
        }
      }).then(res =>{
        this.loading = false
        Toast(res.data.error)
        if (res.data.status === 1) {
            this.showAdd = false
            this.get_list()
        }
      }).catch(err => {
        this.loading = false
      })
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=system_bdm&act=bdm_center",{ params:{token: token }}).then(res =>{
        console.log(res)
        // 加载状态结束
          this.loading = false
        if(res.data.status===1){
          this.task_list = res.data.data.task_list
          this.coin_list = res.data.data.coin_list
          this.info = res.data.data.info
          this.role_type_title = res.data.data.role_type_title
          this.finished = true
          this.loading = false
        }else{
          // 数据全部加载完成
          this.finished = true
          Toast.fail(res.data.error);
        }
      })
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/bdm_center.vue